import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { ModalLayout } from '@/features/modal/modals/ModalLayout';
import { Button } from '@/components/buttons/Button';
import { GTagEvents, triggerGTag } from '@/lib/gTagManager';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';
import { BaseModalProps } from '@/features/modal/types';

export const OntarioMigrationModal = ({ closeModal }: BaseModalProps): JSX.Element | null => {
  const intl = useIntl();
  const locale = useSelector(selectLocale);
  const navigate = useAbsoluteNavigate();

  const onClickHandler = () => {
    triggerGTag(GTagEvents.ontario_check_cta);
    window.location.href = locale === 'ca-fr' ? 'https://luckydays.ca/fr' : 'https://luckydays.ca';
  };

  useEffect(() => {
    // after this modal shows, we want to logout the user after 1 second so that he can't just close the modal and continue playing
    setTimeout(() => {
      navigate('/logout');
    }, 1000);
  }, []);

  return (
    <ModalLayout close={closeModal} data-cy="ontario-migration-modal">
      <div className="w-full max-w-md">
        <h1 className="mb-4 text-center text-xl font-bold">
          {intl.formatMessage({ id: 'ontario.migration.header' })}
        </h1>
        <p className="text-center">{intl.formatMessage({ id: 'ontario.migration.text' })}</p>
        <Button
          text={intl.formatMessage({ id: 'ontario.migration.button' })}
          onClickHandler={onClickHandler}
        />
      </div>
    </ModalLayout>
  );
};
